import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Cache } from 'aws-amplify';
import { withRouter } from 'react-router-dom';
import { Row, Col, Button, Form } from 'react-bootstrap';
import { PORTAL_ADMIN, PROJECT_ADMIN } from '../../../store/actions/users/usersActions';
import { handleInputChange, upsertClient, getClient, resetClient } from '../../../store/actions/clients/clientsActions';

import PageTitle from '../../../common/PageTitle';

class ClientForm extends Component {
  constructor(props) {
    super(props);

    this.submitButtonText = 'Submit';
    this.action = '';
  }

  componentDidMount() {
    const roleId = Cache.getItem('roleId');
    if (roleId === PORTAL_ADMIN || roleId === PROJECT_ADMIN) {
      const pathname = this.props.location.pathname;

      if (pathname === '/settings/clients/update') {
        const urlParams = new URLSearchParams(this.props.location.search);
        const clientCode =  urlParams.get('code');
        this.props.getClient(clientCode);
        this.submitButtonText = 'Update';
        this.action = 'UPDATE_CLIENT';
      }
    }
    else {
      this.props.history.push('/dashboard');
    }
  }

  componentWillUnmount() {
    this.props.resetClient();
  }

  handleSubmit = (e) => {
    e.preventDefault();

    const submitButton = document.querySelector("button[type='submit']");
    submitButton.disabled = true;
    if (this.submitButtonText === 'Submit') {
      submitButton.textContent = "Submitting...";
    }
    else {
      submitButton.textContent = "Updating...";
    } 
    
    this.props.upsertClient(this.action, () => {
      this.props.history.push('/settings/clients');
    })

    submitButton.disabled = false;
    if (this.submitButtonText === 'Submit') {
      submitButton.textContent = "Submitted!";
    }
    else {
      submitButton.textContent = "Updated!";
    }

    setTimeout(() => {  
      submitButton.textContent = this.submitButtonText;
    }, 1000);
  }

  render() {
    let formTitle = '';

    const client = this.props.clients.client;
    
    const pathname = this.props.location.pathname;
    
    if (pathname === '/settings/clients/update') {
      this.submitButtonText = 'Update';
      formTitle = 'Update Client';
      this.action = 'UPDATE_CLIENT';
    }
    else {
      formTitle = 'Create Client';
      this.action = 'ADD_CLIENT';
    }

    let clientName = '';
    let clientCode = '';

    if (Object.keys(client).length) {
      clientName = client.client_name;
      clientCode = client.client_code;
    }

    return (
      <>
        <PageTitle pageName={formTitle} />
        <Form className="mt-3" onSubmit={this.handleSubmit}>
          <Row>
            <Col xs={4} sm={4} md={4} lg={4} xl={4}>
              <Form.Group controlId="client_name">
                <Form.Label>Client Name <span className='required-field'> * </span></Form.Label>
                <Form.Control 
                  type="text" 
                  value={clientName} 
                  onChange={this.props.handleInputChange} />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col xs={4} sm={4} md={4} lg={4} xl={4}>
              <Form.Group controlId="client_code">
                <Form.Label>Client Code <span className='required-field'> * </span></Form.Label>
                <Form.Control 
                  type="text" 
                  value={clientCode}
                  onChange={this.props.handleInputChange} />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col xs={4} sm={4} md={4} lg={4} xl={4}>  
              <div className="float-right">
                <Button variant="default" onClick={() => {
                    this.props.history.push('/settings/clients');
                  }}>Cancel</Button> 
                <Button variant="primary" type="submit">{this.submitButtonText}</Button>
              </div>
            </Col>
          </Row>
        </Form>
      </>
    )
  }
}

export const mapStateToProps = (state) => ({
  clients: state.clients
})

export const mapDispatchToProps = (dispatch) => ({
  handleInputChange: (...args) => dispatch(handleInputChange(...args)),
  upsertClient: (...args) => dispatch(upsertClient(...args)),
  getClient: (...args) => dispatch(getClient(...args)),
  resetClient: () => dispatch(resetClient())
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ClientForm))
